const getServerCookies = async () => {
  const { cookies } = await import('next/headers');
  return cookies();
};

const isServer = typeof window === 'undefined';

export const getSessionCookie = async () => {
  let token: string | null = null;

  if (isServer) {
    const store = await getServerCookies();
    token = store.get('session')?.value ?? null;
  }

  return token;
};

export const getToken = async () => {
  let token: string | null = null;

  if (isServer) {
    const store = await getServerCookies();
    token = store.get('token')?.value ?? null;
  } else {
    const jsCookie = await import('js-cookie');
    const cookies = jsCookie.default;

    token = cookies.get('token') ?? null;
  }

  return token;
};

export const setTokenClient = async (token: string) => {
  const jsCookie = await import('js-cookie');
  const cookies = jsCookie.default;

  cookies.set('token', token);
};

export const removeToken = async () => {
  const jsCookie = await import('js-cookie');
  const cookies = jsCookie.default;

  cookies.remove('token');
};
